import { isPromiseLike } from "@knyt/artisan";
import { createFragmentDeclaration } from "./createFragmentDeclaration.js";
import { isKnytDeclaration } from "./KnytDeclaration.js";
function normalizeAwaitedRenderResult(result) {
    return isKnytDeclaration(result)
        ? result
        : createFragmentDeclaration([result]);
}
/**
 * @internal scope: workspace
 */
export function normalizeRenderResult(result) {
    if (!isPromiseLike(result)) {
        return normalizeAwaitedRenderResult(result);
    }
    return result.then(normalizeAwaitedRenderResult);
}
